export default __webpack_public_path__ + "static/media/Wolf Tamer's Shield.b3c12105.jpg";